var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isModalOpen)?_c('div',{staticClass:"modal-c",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closeModal()}}},[_c('div',{staticClass:"modal-content-c"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }